import { sidebarIcons } from "./sidebarIcons";


const menuItems = [
    {
        items : [
            {
                icon: sidebarIcons.vimList,
                item: "VIM Device List",
                link: "/vim-list",
            },
            {
                icon: sidebarIcons.bmsList,
                item: "BMS Device List",
                link: "/bms-list",
            }
        ]
    }
]

export default menuItems;